module.exports = __webpack_public_path__ + "src/assets/img/page8/9665e45715184528da76a05d8efa5bd9.jpg";